import { defineStore } from 'pinia'

export const useProfileInfoStore = defineStore('profileInfoStore', {
  state: () => ({
    profileInfo: null
  })
})
